import { dateTranslate, mapPlaylistFromVideoSearch, getPitchTypeIdFromName, pitchSubType } from 'yankees-react-utils';

const mapPlaylistFromUrl = (url, title) => ([{
    title: title ?? '',
    sources: [{
        file: url,
    }],
}]);

const mapPlaylistFromApiPlaylist = (playlist, translate, roles) => {
    const clips = playlist.PlayListClipMultiAngles;
    const playlistName = playlist.Name;

    const isMultiAngle = clips[0]?.gameid && clips[0]?.eventseq && clips[0]?.pitchseq;

    if (isMultiAngle) {
        const clipDict = {};
        clips.forEach((clip) => {
            clipDict[`${clip.gameid}.${clip.eventseq}.${clip.pitchseq}`] = clip;
        });
        return Object.values(clipDict)
            .sort((a, b) => a.gamedate?.localeCompare(b.gamedate) || (a.eventseq ?? 0) - (b.eventseq ?? 0) || (a.pitchseq ?? 0) - (b.pitchseq ?? 0))
            .map((clip, videoIndex) => {
                const mappedClip = mapPlaylistFromVideoSearch({ videos: [clip], playervideos: [] }, roles);
                const data = JSON.parse(clip.data);
                const pitchtype = getPitchTypeIdFromName(clip.fxpitchtype, translate) || getPitchTypeIdFromName(clip.pitchtype, translate);
                return {
                    ...mappedClip[0],
                    type: pitchtype || undefined,
                    title: data ? `${videoIndex + 1}. ${data.Batter}${data.Pitcher ? ` ${translate('baseball.abbr-versus')} ${data.Pitcher} - ${dateTranslate(translate, clip.gamedate)}` : ''}`
                        : playlistName,
                    description: data ? `${data.Inning ? `${translate('baseball.inning')}: ${data.Inning}` : ''}${data.Outs ? ` | ${translate('baseball.outs_other')}: ${data.Outs}` : ''} 
                ${data.Count ? ` | ${translate('baseball.abbr-count')}: ${data.Count}` : ''}${data.PitchType ? ` | ${data.PitchType}` : ''}${data.PitchSubType ? ` (${pitchSubType(data.PitchSubType)})` : ''}
                ${data.Velocity ? ` (${data.Velocity})` : ''}${data.Result ? ` | ${translate('common.result')}: ${data.Result}` : ''}` : '',
                    heatmapId: clip.pitcherid && pitchtype ? `${clip.pitcherid}.${pitchtype}.${clip.batterid || clip.islhb || 0}
                    .${clip.strikes === 2}.${clip.yearid || 0}` : null,
                    data: {
                        ...mappedClip[0].data,
                        platex: clip.platex,
                        platez: clip.platez,
                    },
                };
            });
    }
    return clips.map((clip) => ({
        title: playlistName,
        sources: [{
            file: clip.playlistclipurl,
        }],
    }));
};

export {
    mapPlaylistFromApiPlaylist,
    mapPlaylistFromUrl,
};
